module.exports = __webpack_public_path__ + "img/ava-4.f452e777.webp";